import styled from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';
import {Image} from '../../../../uikit/Image';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: row;
  align-items: center;
  padding: ${ms(16)} 0;
`;

export const Content = styled(View)`
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const Avatar = styled(Image)`
  width: ${ms(40)};
  height: ${ms(40)};
  min-width: ${ms(40)};
  min-height: ${ms(40)};
  border-radius: ${ms(20)};
  margin-right: ${ms(12)};
`;

export const Name = styled(Text).attrs({
  nativeProps: {
    numberOfLines: 1,
  },
  weight: 'bold',
})`
  font-size: ${ms(16)};
  line-height: ${ms(21)};
`;
